module.exports = __webpack_public_path__ + "img/money.64b233b4.svg";